function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawSubway = function UndrawSubway(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 982 469.75",
    style: style
  }, props), React.createElement("path", {
    d: "M981 15.75V454a16.28 16.28 0 0 1-.37 3.45 15.43 15.43 0 0 1-15 12.3H15.32a15.29 15.29 0 0 1-14.18-9.81A15.9 15.9 0 0 1 0 454V15.75A15.53 15.53 0 0 1 15.32 0h950.36A15.53 15.53 0 0 1 981 15.75z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    opacity: 0.03,
    d: "M307 45h366v412H307z"
  }), React.createElement("rect", {
    x: 355,
    y: 100,
    width: 114,
    height: 214,
    rx: 14.62,
    opacity: 0.03
  }), React.createElement("rect", {
    x: 620,
    y: 315.13,
    width: 114,
    height: 214,
    rx: 14.62,
    transform: "rotate(-180 622.5 314.565)",
    opacity: 0.03
  }), React.createElement("rect", {
    x: 26,
    y: 52,
    width: 262,
    height: 262,
    rx: 19.62,
    opacity: 0.03
  }), React.createElement("rect", {
    x: 801,
    y: 267.13,
    width: 262,
    height: 262,
    rx: 19.62,
    transform: "rotate(-180 877.5 290.565)",
    opacity: 0.03
  }), React.createElement("path", {
    fill: "#f2f2f2",
    d: "M419.16 100L355 170.24v21.65L434.62 100h-15.46zM469 172.3L355 283.64l.5 19.86 114-111.61-.5-19.59zM575.16 100L511 170.24v21.65L590.62 100h-15.46zM625 172.3L511 283.64l.5 19.86 114-111.61-.5-19.59zM112.97 52L26 151.69v63.91L157 52h-44.03zM228.44 52L26 251v15.12L255.24 52h-26.8zM780.47 52.5l-86.97 99.69v63.91l131-163.6h-44.03zM895.94 52.5l-202.44 199v15.12L922.74 52.5h-26.8zM288 285.32v9.06A19.62 19.62 0 0 1 268.38 314h-33.26c-1-.94-1.93-1.89-2.88-2.86-4.06-4.15-8.17-8.78-10.73-14.49-3.77-8.39-3.53-17.82-3.33-25.39 0-.73.05-1.45.07-2.19a29.14 29.14 0 0 1-53.59-7.93 28.47 28.47 0 0 1-.74-8 29 29 0 0 1 9.42-20.12l10.59 10.16-5.15-14.1a29.1 29.1 0 0 1 40.45 12.64q.47-10.83 1.07-21.62h-.12c-.61-.1-1.22-.23-1.81-.36l-1-.26c-.55-.16-1.1-.32-1.63-.5l-1-.35c-.54-.2-1.08-.44-1.6-.68a9 9 0 0 1-.84-.38c-.65-.31-1.27-.64-1.89-1-.14-.08-.28-.15-.42-.24-.74-.45-1.45-.93-2.14-1.44-.24-.16-.46-.36-.68-.53-.46-.36-.91-.73-1.34-1.1l-.76-.71c-.38-.36-.75-.73-1.1-1.1s-.5-.53-.74-.82-.67-.77-1-1.18l-.65-.84c-.34-.47-.66-.94-1-1.43-.16-.24-.33-.48-.48-.73-.43-.72-.83-1.45-1.2-2.21-.14-.29-.26-.6-.39-.88-.23-.5-.45-1-.65-1.53-.14-.34-.25-.7-.38-1.07s-.31-.94-.45-1.44-.2-.75-.3-1.14c0-.2-.11-.41-.15-.61a28.94 28.94 0 0 1 13.9-31.4l6.52 12.9-.19-15.62a29.14 29.14 0 0 1 34.21 14.78l.09.22c.14.27.26.53.39.81.23.52.46 1 .66 1.58.1.24.2.46.29.7.26.73.48 1.46.69 2.21.07.25.13.51.19.76.17.69.31 1.38.43 2.08 0 .13 0 .25.08.39.12.82.2 1.67.26 2.52v.65c0 .88.05 1.75 0 2.64a29.1 29.1 0 0 1-25.88 27.57c-1 17.08-1.69 34.21-2.13 51.19-.22 8.59-.16 15.65 2.63 21.87a34.65 34.65 0 0 0 5.76 8.5v-1.64a29.14 29.14 0 0 1 30.47-27.76h.08l6.6 13.07-.15-12A29.17 29.17 0 0 1 288 285.32z"
  }), React.createElement("path", {
    opacity: 0.03,
    d: "M484 45h12v412h-12z"
  }), React.createElement("path", {
    d: "M980.63 457.45a15.43 15.43 0 0 1-15 12.3H15.32a15.29 15.29 0 0 1-14.18-9.81c43.13-10.93 157.55-19.78 305.86-23.91q12.39-.36 25.09-.64h1.57c2-.05 4.1-.08 6.16-.14q13.49-.29 27.3-.55l3.18-.06 10.9-.19 3.88-.06q11.49-.18 23.18-.32c24.69-.3 50-.48 75.74-.51h43.82l21.26.14c43.11.29 84.64 1 123.92 2l15.5.43q11.13.3 22 .66c125.22 4 223.39 11.47 270.13 20.66zM288.5 342.5c0 6.07-4.4 11-9.82 11H36.32c-5.42 0-9.82-4.93-9.82-11 0-6.08 4.4-11 9.82-11h242.36c5.42 0 9.82 4.92 9.82 11zM515.82 109.38h34.86v60.15h-34.86z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M515.82 109.38h34.86v60.15h-34.86z"
  }), React.createElement("path", {
    d: "M687.18 158.58c2.08-1.25 4.66-1.17 7.09-1a9 9 0 0 1 4.21.9c2.5 1.51 2.88 4.92 3 7.84.12 3.48.12 7.34-2.2 10-1.84 2.07-4.71 2.83-7.44 3.31a20.15 20.15 0 0 0-5.59 1.42 24.55 24.55 0 0 0-4.86 3.73c-3.25 2.77-7.57 5.49-11.83 6.16-2.86-5.77-3.6-11.3.87-16.26 2.47-2.74 5.66-4.85 8.34-7.39s5.14-6.74 8.41-8.71z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M523 451.16a9.4 9.4 0 0 0-.7 3.79c.28 3 3.25 4.89 6 6.14 3.68 1.69 8.32 2.93 11.52.44 3.56-2.77 3-8.19 4.39-12.49.82-2.51 2.36-4.72 3.37-7.16 2.77-6.69 1.31-14.3-.19-21.38l-2.19-10.31a3.87 3.87 0 0 0-1-2.19c-1.61-1.41-9.16-1.92-11.08-.58-3.07 2.13-2.33 9.32-2.82 12.7a179.48 179.48 0 0 1-7.3 31.04zM511.4 451.16a9.58 9.58 0 0 1 .7 3.79c-.28 3-3.25 4.89-6 6.14-3.68 1.69-8.33 2.93-11.52.44-3.56-2.77-3-8.19-4.4-12.49-.81-2.51-2.35-4.72-3.36-7.16-2.78-6.69-1.31-14.3.19-21.38l2.19-10.31a3.87 3.87 0 0 1 1-2.19c1.61-1.41 9.16-1.92 11.08-.58 3.06 2.13 2.32 9.32 2.81 12.7a179.5 179.5 0 0 0 7.31 31.04z",
    fill: "#575a89"
  }), React.createElement("path", {
    d: "M536.74 141.87a4.67 4.67 0 0 1 1.17 2.07c.36 1.88-1.39 3.54-3.18 4.22s-3.79.84-5.41 1.87a9.39 9.39 0 0 0-3.42 5c-3.4 9.56.39 21.61 9.41 26.26 6.22 3.21 13.62 2.71 20.6 2.13a7.9 7.9 0 0 0 2.85-.6 7.26 7.26 0 0 0 2.32-2.1 40.91 40.91 0 0 0 7.48-35.64 4 4 0 0 0-.59-1.43c-1.8-2.47-6.14.57-8.69-1.11a5.19 5.19 0 0 1-1.69-2.4 51.3 51.3 0 0 1-3.59-12.85c-.08-.54-11.44 3.81-12.41 4.29-3.87 2-4.07.16-6.94 3.43 3.08.86-.46 3.92 2.09 6.86z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M536.74 141.87a4.67 4.67 0 0 1 1.17 2.07c.36 1.88-1.39 3.54-3.18 4.22s-3.79.84-5.41 1.87a9.39 9.39 0 0 0-3.42 5c-3.4 9.56.39 21.61 9.41 26.26 6.22 3.21 13.62 2.71 20.6 2.13a7.9 7.9 0 0 0 2.85-.6 7.26 7.26 0 0 0 2.32-2.1 40.91 40.91 0 0 0 7.48-35.64 4 4 0 0 0-.59-1.43c-1.8-2.47-6.14.57-8.69-1.11a5.19 5.19 0 0 1-1.69-2.4 51.3 51.3 0 0 1-3.59-12.85c-.08-.54-11.44 3.81-12.41 4.29-3.87 2-4.07.16-6.94 3.43 3.08.86-.46 3.92 2.09 6.86z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M496.85 261.1q1 9.66 1.41 19.36c.29 6.21.41 12.57-1.48 18.49-1 3.32-2.71 6.42-3.6 9.78-1 3.95-1 8.09-.95 12.18a28.36 28.36 0 0 0 .66 7c.55 2.09 1.57 4 2.32 6 2.7 7.17 2.08 15.12 1.15 22.72-1.75 14.3-4.48 28.46-7.21 42.6l-4.93 25.64a82.89 82.89 0 0 0 16.68 4.89c3.54.64 8.16.52 9.57-2.8a9.4 9.4 0 0 0 .21-4.69 47.85 47.85 0 0 1 2.42-21.1c1.94-5.49 4.87-10.62 6.36-16.25A58.24 58.24 0 0 0 521 374.1q.69-9.6.58-19.23c-.1-8.66-.65-17.53 1.94-25.8 3.39-10.82 12.07-20.46 11.06-31.76.21 12.45.43 24.91-.41 37.33a123.29 123.29 0 0 0-.6 15.48c.42 7.57 2.61 15.21 1 22.63-.66 3-1.92 5.9-2.25 9-.52 4.82 1.3 9.88-.31 14.46-1.39 4-5.26 7.16-5.14 11.37.08 3.15 2.53 5.84 5.39 7.17s6.08 1.55 9.22 1.75c3.4.22 7.52.08 9.23-2.87 2.09-3.59-1.22-7.83-1.84-11.93s1.57-8.1 3.53-11.78a151.63 151.63 0 0 0 17.72-67.38c.17-7.11-.16-14.23-.12-21.34a206.26 206.26 0 0 1 6-48.41c-26.77-1.02-53.89-.77-79.15 8.31z",
    fill: "#3c354c"
  }), React.createElement("circle", {
    cx: 539.75,
    cy: 121.69,
    r: 20.17,
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M555.15 151.1c-2.18 3.94-4.89 7.87-8.92 9.9s-9.66 1.51-12.19-2.23c-1.91-2.83-1.95-7.08-4.92-8.74-2.38-1.33-5.55-.09-7.2 2.08s-2.14 5-2.46 7.68a158.39 158.39 0 0 0-.7 20.32c.42 33.05 3.06 66.07 2.64 99.13a126.75 126.75 0 0 1-.89 15.46c12.17-3.08 24.42-6.16 37-6.94 6.07-.37 12.18-.2 18.2-1a112.47 112.47 0 0 0 12.27-2.6 2.73 2.73 0 0 0 1.45-.69 2.68 2.68 0 0 0 .5-1.52c1.24-11.69-2.85-23.2-4.66-34.81-1.7-10.83-1.4-21.89-2.86-32.76-2-15.25-7.51-30.1-7.39-45.49 0-5.59.82-11.27-.42-16.73-1-4.5-4.47-10.5-9.5-11.38-5.57-.98-7.85 6.53-9.95 10.32z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M552.91 158.43c-6.17 12.29-12.44 24.85-14.45 38.47-1.81 12.28-.07 24.85-1.56 37.17-1.91 15.82-9.07 31.92-4.21 47.1 1.08 3.39 2.73 6.57 3.88 9.93 5 14.76 0 31.21 3.23 46.47a2.56 2.56 0 0 0 1.15 1.94c.85.37 1.78-.25 2.67-.53 3.85-1.23 6.5 3.66 9.55 6.32a10.27 10.27 0 0 0 11.2 1.36c5.71-2.94 7.23-10.26 8-16.63q5.75-45.7 7-91.83c.19-7 .29-14-.86-20.9-1.39-8.37-4.59-16.33-6.31-24.63-2.76-13.36-1.61-27.17-.86-40.79.21-4-.91-15.52-7.7-11.76-5.22 2.89-8.2 13.28-10.73 18.31z",
    fill: "#575a89"
  }), React.createElement("path", {
    d: "M521.93 192.98c-.06 4.36-.13 8.79-1.47 12.94s-3.92 7.83-6 11.71c-5 9.5-6.81 20.38-7.06 31.1s1 21.42 1.83 32.11a409.16 409.16 0 0 1 .85 48.9 35.74 35.74 0 0 1 20.78-.87c4 1 8.77 2.64 11.9-.08 2.23-1.94 2.5-5.25 2.6-8.2q1.59-45.09 1-90.22a95.08 95.08 0 0 1 .33-11.82c.33-3 1-6.06 1-9.12 0-4.3-1.15-8.5-2.32-12.64l-10.55-37.39c-.69-2.46-1.43-5-3.14-6.92s-6.88-4.46-8.89-2c-1.74 2.16-.45 9.56-.48 12.22z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M520.57 192.29c-.06 4.36-.14 8.8-1.48 12.95s-3.91 7.82-6 11.71c-5 9.5-6.81 20.38-7.06 31.1s1 21.42 1.83 32.11a409 409 0 0 1 .85 48.89 35.86 35.86 0 0 1 20.79-.87c4 1.05 8.76 2.65 11.89-.07 2.23-1.94 2.5-5.25 2.61-8.21q1.58-45.09 1-90.22a94.92 94.92 0 0 1 .32-11.81 88 88 0 0 0 1-9.12c0-4.3-1.14-8.51-2.31-12.64l-10.55-37.39c-.7-2.47-1.44-5-3.15-6.93s-6.88-4.45-8.89-1.95c-1.73 2.15-.44 9.56-.48 12.21z",
    fill: "#575a89"
  }), React.createElement("path", {
    d: "M524.83 146.48c-5.45.55-9.64 5.25-11.77 10.29s-2.75 10.58-4.37 15.8c-2.83 9.05-8.7 17.21-9.65 26.64-.88 8.9 2.76 17.93 1 26.69a54 54 0 0 1-2.11 6.91c-3.4 9.95-5.34 20.33-7.28 30.67l-2.88 15.39c-2 10.85-4.07 22-2.21 32.87a10.27 10.27 0 0 1 13 .83c1 .93 1.83 2.11 3.14 2.31 2.25.32 3.63-2.36 4.22-4.55a136.39 136.39 0 0 0 4.25-23.89c.38-4.38.56-8.82 1.85-13 .82-2.63 2-5.1 2.9-7.71 2-6.17 1.73-12.81 2.56-19.24.71-5.57 2.24-11 3.11-16.54a138.43 138.43 0 0 0 1.19-20.36l.39-39.17c.05-5.07.39-10.8 4.25-14.08 2-1.67 7.19-3.21 6.71-6.35-.47-2.95-6.06-3.73-8.3-3.51zM557.05 142.87c5.84-4.39 12.29-9 19.6-8.82a33 33 0 0 1 7.15 1.24l16.54 4.13a16.34 16.34 0 0 1-7.05 6.5 12 12 0 0 1 13.12 7.23c2.31 6.06-.73 12.7-3.42 18.61-4.6 10.09-8.42 20.83-8.38 31.93 0 5.63-3.89 11.2-4.27 16.82a33 33 0 0 0 .86 10.49 70.44 70.44 0 0 0 3.76 9.76c10.13 23.78 12.43 50.23 11.31 76.06h-22.58a10 10 0 0 0-3.69.47c-1.42.55-2.49 1.71-3.75 2.57a9.93 9.93 0 0 1-7.4 1.54c-2.41-11 1.4-22.18 3.28-33.24a164.25 164.25 0 0 0 1.81-18.29q.79-14.56.8-29.17c0-7.36-.18-14.87-2.61-21.81-1.2-3.44-2.94-6.69-4.07-10.16a61 61 0 0 1-2.1-10.65c-2.52-18.59-6.39-36.64-8.91-55.21z",
    fill: "#ff6584"
  }), React.createElement("path", {
    d: "M508.78 158.43c-1.7 1.24-2.2 3.5-2.95 5.47-1.88 4.94-5.87 8.74-8.49 13.32a53 53 0 0 0-3.72 8.82c-3.47 9.9-7 20.23-5.76 30.64.28 2.33.87 4.77 2.52 6.44 3.61 3.63 10.28 1.39 13.07-2.91s2.95-9.7 3.51-14.78c1.06-9.68 3.87-19 6-28.5a111 111 0 0 0 2.52-14.48c.15-1.5 1-4.84-.42-5.79-.89-.6-5.45 1.21-6.28 1.77zM619.06 185.1c2.49 3 5.52 6.17 9.38 6.07a13.3 13.3 0 0 0 5.41-1.81 259.71 259.71 0 0 1 40.33-16.07 18.76 18.76 0 0 0 4.39 21.18 139 139 0 0 0-33.5 13.4 28.74 28.74 0 0 0-6.17 4.29 40.82 40.82 0 0 1-3.86 3.92c-3.06 2.34-7.21 2.5-11.07 2.56a16.18 16.18 0 0 1-12.72-3.89L583.63 195a2.95 2.95 0 0 1-.92-4.81l8.74-15.59c2-3.53 4.25-9.37 8.94-10s6.41 4.41 8.63 7.71a146.38 146.38 0 0 0 10.04 12.79z",
    fill: "#ff6584"
  }), React.createElement("rect", {
    x: 598.85,
    y: 366.89,
    width: 18.46,
    height: 38.28,
    rx: 4.1,
    transform: "rotate(-21.57 -10.989 564.606)",
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 598.85,
    y: 366.89,
    width: 18.46,
    height: 38.28,
    rx: 4.1,
    transform: "rotate(-21.57 -10.989 564.606)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 597.48,
    y: 367.57,
    width: 18.46,
    height: 38.28,
    rx: 4.1,
    transform: "rotate(-21.57 -12.371 565.295)",
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 496.34,
    cy: 165.09,
    r: 2.39,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M489.56 188.52c-1.24-1.54-2.79-2.82-3.88-4.46a17.1 17.1 0 0 1-2.28-7.19 66.48 66.48 0 0 1-.65-8.35 2.43 2.43 0 0 1 3-2.4 19.68 19.68 0 0 1 10.28 6.2 26.64 26.64 0 0 1 6.08 13.67 67.88 67.88 0 0 1 .57 7.81l.36 10.71c-2.61 0-6.41.73-8.91 0-3.59-1-2.14-.37-1.78-3.9.41-4.4.11-8.49-2.79-12.09z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M496.61 199.97a9.61 9.61 0 0 1-4.23-.58c-2.74-1.15-4.31-4-5.67-6.63a94.86 94.86 0 0 1-.88 17.19c-.52 3-1.33 6-1.26 9.07a15.93 15.93 0 0 0 4.3 10.44 7.48 7.48 0 0 0 2.64 1.93c2.16.85 4.62.06 6.6-1.14a16.73 16.73 0 0 0 6.55-7.38c2-4.44 1.9-9.33 2-14.09.1-4.45 1.53-9.12 1.45-13.39-3.46-.41-7.29 4.36-11.5 4.58z",
    fill: "#ff6584"
  }), React.createElement("path", {
    d: "M516.69 114.61a27.63 27.63 0 0 0 23 1.28c-1.17 5.11 1.51 10.21 2.9 15.27 3.66 13.33-2 27.81-11 38.28a28 28 0 0 0 22.77-8.25 59.61 59.61 0 0 1-11.24 18.73c17.31-5.39 29.67-21.44 35.22-38.7 4.24-13.22 5-28.06-.78-40.67s-19.06-22.24-32.89-21.1c-10.09.83-19.32 7.27-24.45 16s-6.3 19.42-4.22 29.42z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M542.63 131.16a36.14 36.14 0 0 1-1.27 21.77c3.57-8 4.94-16.82 2.64-25.19-1.39-5.06-4.08-10.16-2.91-15.27a27.61 27.61 0 0 1-23-1.28l-.28 4a27.65 27.65 0 0 0 22 .74c-1.25 5.07 1.43 10.17 2.82 15.23zM518.61 98.64a42.51 42.51 0 0 0-2.61 26.23l.61-8.58a42.3 42.3 0 0 1 2-17.65zM555.77 157.77a28.1 28.1 0 0 1-21.49 8.35 54.28 54.28 0 0 1-2.65 3.32 28 28 0 0 0 22.69-8.18c.52-1.15 1.01-2.31 1.45-3.49zM546.45 175.87c-1 1.41-2.13 2.77-3.29 4.08 16.29-5.07 28.2-19.59 34.16-35.67-6.05 14.03-16.7 26.4-30.87 31.59z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M710.5 42.5V.5h-22v442a11 11 0 1 0 22 0v-378h54v31.15c-19.18 1.2-34 9.17-34 18.85 0 8.9 12.6 16.39 29.59 18.44a79.45 79.45 0 0 0 9.41.56c21.54 0 39-8.52 39-19 0-7.2-8.2-13.46-20.3-16.68a70.76 70.76 0 0 0-13.7-2.17V64.5h110v31.15a74.56 74.56 0 0 0-9.2 1.15c-14.52 2.77-24.8 9.65-24.8 17.7a9.81 9.81 0 0 0 1.09 4.45c4.11 8.34 19.52 14.55 37.91 14.55 21.54 0 39-8.52 39-19 0-9.68-14.82-17.65-34-18.85V64.5H982v-22zm210 72c0 8.33-13.88 15.09-31 15.09s-31-6.76-31-15.09a7.3 7.3 0 0 1 .39-2.36c1.06-3.34 4.36-6.3 9.11-8.51a49.32 49.32 0 0 1 17.93-4.13h7.14c15.44.85 27.43 7.25 27.43 15zm-135.23-13c9.12 2.65 15.23 7.48 15.23 13 0 8.33-13.88 15.09-31 15.09a61.84 61.84 0 0 1-6.47-.33c-14-1.44-24.53-7.5-24.53-14.76 0-7.75 12-14.15 27.43-15h7.14a56.47 56.47 0 0 1 12.2 1.98z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    fill: "#575a89",
    d: "M381.22 232.37h3.52v107.47h-3.52zM392.15 232.37h3.53v107.47h-3.53z"
  }), React.createElement("circle", {
    cx: 373.43,
    cy: 444.42,
    r: 6.02,
    fill: "#575a89"
  }), React.createElement("path", {
    d: "M352.11 334.87s6-4.88 11.27-3.19 19 3.38 21.4 12 0 103.45 0 103.45-11.64 3-14.83 1.5-2.82-15.76-2.82-15.76l-.93-84.11z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M352.11 334.87s6-4.88 11.27-3.19 19 3.38 21.4 12 0 103.45 0 103.45-11.64 3-14.83 1.5-2.82-15.76-2.82-15.76l-.93-84.11z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M406.75 442.27l-25.27 5.6-.26-4.49-.17-88.47a26.94 26.94 0 0 0-10.58-21.37s13.09-.17 23.12 4.35c2.14 1 4.29 1.91 6.49 2.72 2.73 1 6.43 3.15 6.67 7.39.31 5.52 1.36 60.2 1.74 80.11a50.39 50.39 0 0 1-1.74 14.14z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#535461",
    d: "M379.57 224.39h5.87v9.2h-5.87z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M379.57 224.39h5.87v9.2h-5.87z"
  }), React.createElement("path", {
    fill: "#535461",
    d: "M390.6 225.85h5.87v9.2h-5.87z"
  }), React.createElement("path", {
    d: "M396.47 225.87h-5.87a5.83 5.83 0 0 0-5.16 3.43c-.08.18-.16.36-.24.56l-1.29-1.25-2.69-2.6-1.65-1.59s10.84-5.55 16.9 1.45z",
    fill: "#535461"
  }), React.createElement("circle", {
    cx: 399.03,
    cy: 448.66,
    r: 6.02,
    fill: "#575a89"
  }), React.createElement("circle", {
    cx: 336.86,
    cy: 440.44,
    r: 6.02,
    fill: "#575a89"
  }), React.createElement("path", {
    d: "M348.17 333.56s-17.08 4.51-18 47.5-1.13 47.5-1.13 47.5.38 12.4 25.53 20.09H370l2.39-98.78s-2.82-15-24.22-16.31z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M346.67 400.21s-4.38-60.11 19.22-60.38l2.21 2.16s-20.68-7.49-21.43 58.22z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 357.28,
    cy: 453.91,
    r: 6.02,
    fill: "#575a89"
  }), React.createElement("path", {
    d: "M390.67 225.81h-.06a5.83 5.83 0 0 0-5.16 3.43c-.08.18-.16.36-.24.56l-1.29-1.25a1.82 1.82 0 0 1 0-.33 3.41 3.41 0 0 1 1.28-2.22 5.06 5.06 0 0 1 4.89-.88c.29.14.64.37.58.69z",
    opacity: 0.1
  }));
};
UndrawSubway.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawSubway;